import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { PageBody } from "@/components/Page";
import { SequenceEditor } from "@/pages/Campaigns";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import api from "@/lib/api";

export default function CampaignPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [c, setC] = useState(null);
  const load = () => api.get(`/campaigns/${id}`).then((r) => setC(r.data)).catch(() => setC(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [id]);
  useDocumentTitle(c && c.name ? c.name : "Campaign");

  return (
    <PageBody>
      {c === false ? (
        <p className="text-sm text-muted-foreground">Campaign not found.</p>
      ) : c ? (
        <SequenceEditor campaign={c} onBack={() => navigate("/app/campaigns")} reload={load} />
      ) : (
        <p className="text-sm text-muted-foreground">Loading…</p>
      )}
    </PageBody>
  );
}
